/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { Action } from '@atlassian/react-sweet-state';
import { KEY_HAS_EVER_SEEN_ROUTE } from '../../../common/constants.tsx';
import { pushToBackend } from '../../../common/utils/push-to-backend.tsx';
import type { State, HasEverSeenRoute } from '../../model/types.tsx';

export const setHasEverSeenRoute =
	(update: Partial<HasEverSeenRoute>): Action<State> =>
	({ getState, setState }) => {
		const { hasEverSeenRoute: currentHasEverSeenRoute } = getState();

		const somethingHasBeenUpdated = Object.keys(update).some(
			// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<"jsw.onboarding.experiment.personalised.onboarding.ntkw.onboarding.it2.roadmap", boolean>>'.
			(key) => update[key] !== currentHasEverSeenRoute[key],
		);

		if (!somethingHasBeenUpdated) {
			return;
		}

		const newHasEverSeenRoute: HasEverSeenRoute = {
			...currentHasEverSeenRoute,
			...update,
		};

		setState({
			hasEverSeenRoute: newHasEverSeenRoute,
		});

		pushToBackend({
			key: KEY_HAS_EVER_SEEN_ROUTE,
			value: newHasEverSeenRoute,
		});
	};

export default setHasEverSeenRoute;
